import React from 'react'
import { InputField } from '@enamelai/design-system'
import { formatPhoneNumber } from '@utils/numberFormatter.util'
import ReviewSections from '../../../shared/ReviewSections'

interface ReviewInfoProps {
  phoneNumber: string
  lineName: string
  setLineName: (value: string) => void
  monthlyFee: string
  setupFee: string
  totalDue: string
}

const ReviewInfo: React.FC<ReviewInfoProps> = ({
  phoneNumber,
  lineName,
  setLineName,
  monthlyFee,
  setupFee,
  totalDue,
}) => {
  const renewsOn = new Date()
  renewsOn.setMonth(renewsOn.getMonth() + 1)
  const renewsOnFormatted = `${String(renewsOn.getMonth() + 1).padStart(2, '0')}/${String(
    renewsOn.getDate(),
  ).padStart(2, '0')}/${renewsOn.getFullYear()}`

  return (
    <div className="scp-pm-card">
      <InputField
        variant="text"
        fullWidth
        label="Line name (optional)"
        placeholder="e.g. Front desk fax"
        value={lineName}
        onChange={(event) => setLineName(event.target.value)}
      />
      <ReviewSections
        sections={[
          {
            id: 'number',
            title: 'Number',
            showInfo: true,
            fields: [
              {
                label: 'Selected number',
                value: formatPhoneNumber(phoneNumber, false),
              },
            ],
          },
          {
            id: 'billing',
            title: 'Billing',
            showInfo: true,
            fields: [
              { label: 'Renews on', value: renewsOnFormatted },
              { label: 'Monthly fee', value: monthlyFee },
              { label: 'Setup fee', value: setupFee },
              { label: 'Total due', value: totalDue },
            ],
          },
        ]}
      />
    </div>
  )
}

export default ReviewInfo
